/* eslint-disable react/jsx-props-no-spreading */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import * as fab from '@fortawesome/free-brands-svg-icons';
import * as far from '@fortawesome/free-regular-svg-icons';
import * as fas from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

const modules = { ...fas, ...fab, ...far };
const moduleKeys = Object.keys(modules);

export default function Icon({ logo, ...props }) {
  let i = modules[logo || ''];

  return <FontAwesomeIcon icon={i} {...props} />;
}

Icon.propTypes = {
  logo: PropTypes.oneOf(moduleKeys).isRequired
};
